import styles from './SliderPromotions.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/store'
import { fetchPartnerPromotions, getMobileApps } from '@/store/slices/stagesSlice/stagesSlice'
import Slider from 'react-slick'
import cn from 'classnames'
import { useEffect, useState } from 'react'
import { getUserAgent } from '@/helpers/getUserAgent'
import { OperatingSystem } from '@/constants'
import { yandexMetrika } from '@/helpers/yandexMetrika'
import PromoModal from '@/components/PromoModal'
import { PartnerPromotion } from '@/store/slices/stagesSlice/interfaces'
import { ModalButtonsLinks } from '@/components/SliderPromotions/components/ModalButtonsLinks/ModalButtonsLinks'
import { sliderSettings } from '@/components/SliderPromotions/SliderPromotions.helpers'
import { SliderCard } from '@/components/SliderPromotions/components/SliderCard/SliderCard'
import { ONELINK_MOBILE_APP } from '@/constants/links'

interface ISliderPromotionsProps {
  onSwipe?: () => void
}

export const SliderPromotions = ({ onSwipe }: ISliderPromotionsProps) => {
  const reduxState = useSelector<RootState, RootState>(state => state)
  const { data: mobileApps } = getMobileApps(reduxState)
  const partnerPromotions = reduxState.stages.partnerPromotions.data
  const dispatch = useDispatch()
  const [operatingSystem, setOperatingSystem] = useState<OperatingSystem | 'other'>('other')
  const [openModalLinks, setOpenModalLinks] = useState<boolean>(false)
  const [openModalPromo, setOpenModalPromo] = useState<boolean>(false)
  const [selectedPartnerPromotion, setSelectedPartnerPromotion] = useState<PartnerPromotion | null>(
    null,
  )

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchPartnerPromotions())
    }
    fetchData()
  }, [])

  useEffect(() => {
    const operatingSystem = getUserAgent()
    setOperatingSystem(operatingSystem)
  }, [])

  const links = {
    android: {
      onClick: yandexMetrika.reachGoalButtonClickGooglePlayNew,
      onView: yandexMetrika.reachGoalButtonViewGooglePlayNew,
    },
    ios: {
      onClick: yandexMetrika.reachGoalButtonClickAppStoreNew,
      onView: yandexMetrika.reachGoalButtonViewAppStoreNew,
    },
    other: {
      onClick: undefined,
      onView: yandexMetrika.reachGoalButtonViewNotDetected,
    },
  }

  useEffect(() => {
    if (operatingSystem && links[operatingSystem]) {
      links[operatingSystem].onView()
    }
  }, [operatingSystem, links])

  const handleSwipe = () => {
    onSwipe?.()
  }

  return (
    <>
      <div
        className={cn(styles.container, {
          [styles.container_noPartner]: !partnerPromotions?.length,
        })}
      >
        <Slider {...sliderSettings(partnerPromotions, handleSwipe)}>
          <div className={cn(styles.containerSlide, styles.containerSlide_default)}>
            <a
              target="_blank"
              href={operatingSystem === OperatingSystem.IOS ? ONELINK_MOBILE_APP : ''}
              onClick={evt => {
                if (operatingSystem === OperatingSystem.Android) {
                  evt.preventDefault()
                  setOpenModalLinks(true)
                }
              }}
            >
              <article className={styles.promo}>
                <h3 className={styles.promo__title}>
                  Оплачивайте парковку ещё&nbsp;быстрее в приложении
                </h3>
                <p className={styles.promo__desc}>Скачать приложение</p>
              </article>
            </a>
          </div>
          {partnerPromotions &&
            partnerPromotions.map(promo => (
              <SliderCard
                key={promo.id}
                promo={promo}
                setSelectedPartnerPromotion={setSelectedPartnerPromotion}
                setOpenModalPromo={setOpenModalPromo}
                setOpenModalLinks={setOpenModalLinks}
                operatingSystem={operatingSystem}
                ios_link={ONELINK_MOBILE_APP}
              />
            ))}
        </Slider>
      </div>
      {openModalLinks && (
        <ModalButtonsLinks setOpenModalLinks={setOpenModalLinks} mobileApps={mobileApps} />
      )}
      {openModalPromo && selectedPartnerPromotion && (
        <PromoModal setIsOpen={setOpenModalPromo} partnerPromotion={selectedPartnerPromotion} />
      )}
    </>
  )
}
